import { GET_PAGES, GET_BLOG, SET_BLOG, GET_CURRENT_BLOG } from './mutation-types.js'

const mutations = {
  [GET_PAGES] (state, data) {
    state.pages = data
    state.loading = false
  },
  [GET_BLOG] (state, data) {
    state.blog = data
    state.blog.current_page = {}
    state.blog.current_page.number = 1
  },
  [SET_BLOG] (state, data) {
    state.sortedBlog = data
  },
  [GET_CURRENT_BLOG] (state, data) {
    const currentPost = data
    for (let i = 0; i < state.blog.data.length; i++) {
      if (state.blog.data[i].slug === currentPost) {
        state.currentBlog = state.blog.data[i]
      }
    }
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/shared/store/mutations.js